module.exports = __webpack_public_path__ + "media/images/common/star-yellow-8955e77fb62cdbebaa7cd9e089ff5f1e.svg";